// extracted by mini-css-extract-plugin
export default {"modalwrapper":"modal_modalwrapper__xsm9x","modaldialog":"modal_modaldialog__V32Nq"};